import React, { useState, useEffect } from "react";
import { Header } from "../../internal/Header/Header";
import Login from "../../internal/Login/Login";
import _ from "lodash";
import { Images } from "../../../assets/images";
import Footer from "../NewLandingPage/components/Footer";
import styled from "styled-components";

const passwords = {
  name: "password",
  label: "Password",
  type: "password",
  placeholder: "Enter your Password",
  required: true,
};

const Index = ({ location = {} }) => {
  const [currentTab, setCurrentTab] = useState("email");
  const [inputs, setInputs] = useState([
    {
      name: "email",
      label: "Registered Email",
      type: "email",
      placeholder: "Enter Your Email",
    },
    passwords,
  ]);

  useEffect(() => {
    if (currentTab) {
      setInputs([
        {
          name: currentTab,
          label: `Registered ${_.capitalize(currentTab)}`,
          type: currentTab === "mobile" ? "number" : currentTab,
          placeholder: `Enter Your ${_.capitalize(currentTab)}`,
          required: true,
        },
        passwords,
      ]);
    }
  }, [currentTab]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Header>
      <Container>
        <LeftPanel>
          <SignupContainer>
            <Login
              heading="LOGIN"
              inputs={inputs}
              {...{ currentTab, setCurrentTab, location }}
            />
          </SignupContainer>
        </LeftPanel>
        <RightPanel>
          <ResponsiveImage src={Images.Login} alt="Login Illustration" />
        </RightPanel>
      </Container>
      <Footer />
    </Header>
  );
};

export default Index;

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  overflow-x: hidden;

  @media (max-width: 1024px) {
    flex-direction: column;
    min-height: auto;
    padding: 1rem;
  }

  @media (max-width: 768px) {
    padding: 0.5rem;
  }

  @media (max-width: 600px) {
    padding: 0;
  }
`;

export const LeftPanel = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  min-height: 100vh;
  width: 100%;

  @media (max-width: 1024px) {
    min-height: auto;
    padding: 2rem 1rem;
    order: 2;
  }

  @media (max-width: 768px) {
    min-height: auto;
    padding: 1.5rem 1rem;
    order: 2;
  }

  @media (max-width: 480px) {
    padding: 1rem 0.5rem;
  }

  @media (max-width: 360px) {
    padding: 0.75rem 0.25rem;
  }
`;

export const RightPanel = styled.div`
  flex: 1;
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  min-height: 90vh;
  position: relative;
  overflow: hidden;

  @media (max-width: 1024px) {
    min-height: auto;
    height: auto;
    order: 1;
    width: 100%;
    padding: 2rem 1rem;
  }

  @media (max-width: 768px) {
    min-height: auto;
    height: auto;
    order: -1;
    padding: 1.5rem 1rem;
  }

  @media (max-width: 480px) {
    height: auto;
    padding: 1rem 0.5rem;
  }

  @media (max-width: 360px) {
    height: auto;
    padding: 0.75rem 0.25rem;
  }
`;

export const SignupContainer = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 2.5rem 3rem;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 2;

  @media (max-width: 1024px) {
    width: 95%;
    padding: 2rem;
  }

  @media (max-width: 768px) {
    width: 95%;
    padding: 1.5rem;
    border-radius: 12px;
  }

  @media (max-width: 480px) {
    padding: 1rem;
    border-radius: 8px;
  }

  @media (max-width: 360px) {
    padding: 0.75rem;
    border-radius: 6px;
  }
`;

export const ResponsiveImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 600px;
  border-radius: 12px;

  @media (max-width: 480px) {
    max-width: 100%;
    border-radius: 8px;
  }
`;
